export const pdfFilledButtonSx = {
  color: 'primary.contrastText',
  '&:hover': {
    color: 'primary.contrastText',
  },
  '&.Mui-focusVisible': {
    color: 'primary.contrastText',
  },
  '&.Mui-disabled': {
    backgroundColor: 'action.disabledBackground',
    backgroundImage: 'none',
    boxShadow: 'none',
    color: 'text.secondary',
  },
} as const;
